// Onboarding API — POST /onboard → { content, metadata } greeting
// (metadata carries engine_scale for the session_start buttons).
// tags + mood_score are the legacy payload; display_name / tone carry the
// redesigned step 1-2 profile that the backend persists and renders into
// the bot's prompt; the build-defined payload rides `custom` + `journey`.
import { api } from './client'
import type { ServerMessage } from '../types/api'

import type { OnboardingPayload } from '../features/onboarding'

interface OnboardParams extends OnboardingPayload {
  displayName?: string | null
  tone?: string
}

export const onboardingApi = {
  submit: ({ tags, moodScore, communicationStyle, addressGender, custom, journey, displayName, tone }: OnboardParams) =>
    api.post<ServerMessage>('/onboard', {
      tags,
      mood_score: moodScore,
      ...(communicationStyle ? { communication_style: communicationStyle } : {}),
      ...(addressGender ? { address_gender: addressGender } : {}),
      display_name: displayName || null,
      tone: tone || null,
      ...(custom ? { custom } : {}),
      ...(journey ? { journey } : {}),
    }),
}
